import type { TranslationInterface } from '.';

export const ThaiLanguage: TranslationInterface = {
  write_a_message_placeholder: 'เขียนข้อความ...',
  your_issue_has_been_resolved: 'ปัญหาของคุณได้รับการแก้ไขแล้ว!',
  new_conversation: 'การสนทนาใหม่',
  welcome_screen_title: 'ยินดีต้อนรับสู่แชทสนับสนุนของเรา',
  welcome_screen_description:
    'เราพร้อมช่วยเหลือคุณ! เริ่มการสนทนาและเราจะติดต่อกลับโดยเร็วที่สุด',
  your_name_placeholder: 'ชื่อของคุณ',
  your_email_placeholder: 'ที่อยู่อีเมลของคุณ',
  start_chat_button: 'พูดคุยกับฝ่ายสนับสนุน',
  start_chat_button_loading: 'กำลังเชื่อมต่อ...',
  i_need_more_help: 'ฉันต้องการความช่วยเหลือเพิ่มเติม',
  this_was_helpful: 'สิ่งนี้เป็นประโยชน์',
  optional: 'ไม่บังคับ',
  no_conversations_yet: 'ยังไม่มีการสนทนา',
  back_to_conversations: 'กลับไปที่การสนทนา',
  closed_conversations: 'การสนทนาที่ปิดแล้ว',
  csat_title: 'การสนทนาของคุณเป็นอย่างไรบ้าง?',
  csat_submitted_title: 'คุณให้คะแนนการสนทนาว่า',
  csat_feedback_placeholder: 'บอกเราเพิ่มเติม... (ไม่บังคับ)',
  follow_up_placeholder: 'ถามต่อ…',
  companion_layout_label: 'เค้าโครง',
  companion_layout_floating: 'แบบลอย',
  companion_layout_sidebar: 'แถบด้านข้าง',
  companion_layout_fullscreen: 'เต็มหน้าจอ',
  companion_close: 'ปิด',
  companion_history: 'ประวัติการสนทนา',
  companion_expand_chat: 'ขยายแชต',
  companion_sidebar_dock_label: 'เชื่อมต่อ',
  companion_sidebar_side_label: 'ด้าน',
  companion_sidebar_left: 'ซ้าย',
  companion_sidebar_right: 'ขวา',
  companion_resize_chat: 'ปรับขนาดแชต',
  scroll_to_bottom: 'เลื่อนไปด้านล่าง',
  thinking: 'กำลังคิด…',
  running: 'กำลังทำงาน…',
  steps: 'ขั้นตอน',
  step_arguments: 'อาร์กิวเมนต์',
  step_result: 'ผลลัพธ์',
  attach_files: 'แนบรูปภาพ วิดีโอ PDF หรือสเปรดชีต (ขนาดสูงสุด 25 MB)',
  mark_page_active:
    'คลิกสิ่งใดก็ได้บนหน้าเพื่อทำเครื่องหมาย — กด Esc เพื่อยกเลิก',
  mark_page: 'ทำเครื่องหมายสิ่งที่อยู่บนหน้าเพื่อถามเกี่ยวกับสิ่งนั้น',
  stop_response: 'หยุดการตอบ',
  copy_reply: 'คัดลอกคำตอบ',
  mentions_empty: 'ไม่พบรายการ',
  copied: 'คัดลอกแล้ว',
  send_message: 'ส่งข้อความ',
  upload_failed: 'อัปโหลดไม่สำเร็จ: {error}',
  remove_attachment: 'ลบไฟล์แนบ',
  json_no_items: 'ไม่มีรายการ',
  json_no_data: 'ไม่มีข้อมูล',
  json_no_chart_data: 'ไม่มีข้อมูลสำหรับแผนภูมิ',
  json_unsupported: 'ไม่รองรับ: {type}',
  json_see_less: 'ดูน้อยลง',
  json_phone_agent: 'เอเจนต์โทรศัพท์',
  json_phone_agent_test: 'ทดสอบผ่านเว็บ',
  page_context_remove: 'ลบบริบทของหน้า',
  json_see_more: 'ดูเพิ่มอีก {count} รายการ',
  queued_label: '{count} อยู่ในคิว',
  remove_queued_message: 'นำข้อความออกจากคิว',
  send_queued_now: 'ส่งข้อความในคิวตอนนี้',
  turn_failed_message: 'เกิดข้อผิดพลาดและไม่ได้รับคำตอบ',
  turn_failed_retry: 'ลองอีกครั้ง',
  page_mark_hint: 'คลิกสิ่งใดก็ได้เพื่อทำเครื่องหมาย',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'กรอบ',
  page_mark_shape_circle: 'วงกลม',
  page_mark_shape_arrow: 'ลูกศร',
  page_mark_shape_bracket: 'วงเล็บ',
  page_mark_shape_underline: 'ขีดเส้นใต้',
  page_mark_shape_highlight: 'ไฮไลต์',
  page_mark_shape_strike_through: 'ขีดฆ่า',
  page_mark_shape_crossed_off: 'กากบาท',
  page_mark_shape_aria: 'รูปร่างเครื่องหมาย: {shape}',
  page_mark_note_placeholder: 'เพิ่มหมายเหตุ… (กด Enter เพื่อแนบ)',
  page_mark_attach: 'แนบเครื่องหมาย',
  page_mark_remove: 'ลบ {label}',
  page_mark_region: 'บริเวณที่ทำเครื่องหมาย',
  page_mark_default_message: 'นี่คืออะไร',
  file_rejected: 'ไม่รองรับประเภทไฟล์หรือไฟล์มีขนาดใหญ่เกินไป',
  dictate: 'พูดเพื่อพิมพ์',
  stop_dictation: 'หยุดการพูดเพื่อพิมพ์',
  dictation_mic_blocked: 'อนุญาตการเข้าถึงไมโครโฟนเพื่อพูดเพื่อพิมพ์',
  dictation_unavailable: 'ไม่สามารถใช้การพูดเพื่อพิมพ์ได้ในขณะนี้',
  questions_back: 'ย้อนกลับ',
  questions_next: 'ถัดไป',
  questions_send: 'ส่ง',
  questions_type_answer: 'ขอพิมพ์เอง',
  questions_answer_placeholder: 'พิมพ์คำตอบของคุณ…',
  close_conversation_title: 'ปิดการสนทนา',
  close_conversation_description: 'คุณแน่ใจหรือไม่ว่าต้องการปิดการสนทนานี้?',
  close_conversation_cancel: 'ไม่',
  close_conversation_confirm: 'ใช่',
  dialog_close: 'ปิด',
  zoom_in: 'ขยาย',
  zoom_out: 'ย่อ',
  reset_zoom: 'รีเซ็ตการซูม',
  support_chat_aria_label: 'แชทฝ่ายสนับสนุน',
};
